// extracted by mini-css-extract-plugin
export default {"footer":"footer_footer__P+soO","containerFluid":"footer_containerFluid__0sJOx"};